export const routeCreatorTutorialSteps = [
  {
    target: '#logistics-route-hero',
    title: 'Nueva hoja de ruta',
    content:
      'Acá armás la salida del día para una unidad. Elegís fecha, chofer, unidad y dejás lista la hoja que después va a usar el transportista.',
    narration:
      'Acá armás la salida del día para una unidad. Elegís fecha, chofer, unidad y dejás lista la hoja que después va a usar el transportista.',
    audio: '/tutorials/ruta/01-hoja.mp3?v=2',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#logistics-route-scheduled-services',
    title: 'Servicios programados',
    content:
      'Acá ves lo que ya estaba pactado para esta unidad, este chofer y esta fecha. Podés activarlo directo y cargarlo a la hoja sin volver al módulo Servicio.',
    narration:
      'Acá ves lo que ya estaba pactado para esta unidad, este chofer y esta fecha. Podés activarlo directo y cargarlo a la hoja sin volver al módulo Servicio.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '#logistics-route-pending-services',
    title: 'Servicios pendientes',
    content:
      'Acá aparecen los servicios ya enviados a logística. Los que siguen libres se pueden sumar a esta hoja y los que ya tomó otra ruta quedan bloqueados en gris para evitar conflictos.',
    narration:
      'Acá aparecen los servicios ya enviados a logística. Los que siguen libres se pueden sumar a esta hoja y los que ya tomó otra ruta quedan bloqueados en gris para evitar conflictos.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#logistics-route-destination-form',
    title: 'Formulario de destino',
    content:
      'Desde acá cargás una parada manual o completás un destino que no vino desde servicios. Si el punto ya existe, el sistema lo autocompleta y, si no existe, también podés darlo de alta desde el mismo flujo.',
    narration:
      'Desde acá cargás una parada manual o completás un destino que no vino desde servicios. Si el punto ya existe, el sistema lo autocompleta y, si no existe, también podés darlo de alta desde el mismo flujo.',
    audio: '/tutorials/ruta/03-destino.mp3?v=2',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '#logistics-route-loads-panel',
    title: 'Carga operativa',
    content:
      'En este bloque definís qué se mueve en cada parada: producto, cantidad, acción y evidencia requerida. Eso deja trazabilidad operativa y, si corresponde, también de stock.',
    narration:
      'En este bloque definís qué se mueve en cada parada: producto, cantidad, acción y evidencia requerida. Eso deja trazabilidad operativa y, si corresponde, también de stock.',
    audio: '/tutorials/ruta/04-carga.mp3?v=2',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '#logistics-route-preview',
    title: 'Vista previa del recorrido',
    content:
      'Acá revisás el orden completo de la hoja antes de guardarla: destinos, carga, servicios vinculados y prioridades. Es el último control antes de salir.',
    narration:
      'Acá revisás el orden completo de la hoja antes de guardarla: destinos, carga, servicios vinculados y prioridades. Es el último control antes de salir.',
    audio: '/tutorials/ruta/05-preview.mp3?v=2',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '#logistics-route-save-actions',
    title: 'Guardar y activar',
    content:
      'Cuando terminás, podés dejar la ruta programada o activarla para trabajarla enseguida. Si la activás, queda lista para el chofer y para el seguimiento en monitor.',
    narration:
      'Cuando terminás, podés dejar la ruta programada o activarla para trabajarla enseguida. Si la activás, queda lista para el chofer y para el seguimiento en monitor.',
    audio: '/tutorials/ruta/06-guardar.mp3?v=2',
    placement: 'top',
    disableBeacon: true,
  },
];

export default routeCreatorTutorialSteps;
